import { useQueryClient } from 'shared-ui';
import { toast } from 'react-toastify';

import { QueryKeyEnum } from 'core/global.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { archiveGlc } from 'api/glc/glc';
import { useMutation } from 'hooks/useMutation/useMutation';
import { useSelectedGlc } from 'hooks/useSelectedGlc/useSelectedGlc';
import { useModalState } from 'hooks/useModalState/useModalState';

import { ArchiveGlc } from './ArchiveGlc';
import { ArchiveGlcContainerProps } from './ArchiveGlc.types';

export const ArchiveGlcContainer = ({ selectedGlc }: ArchiveGlcContainerProps) => {
  const queryClient = useQueryClient();
  const { formatMessage } = useLocale();
  const { setSelectedGlc } = useSelectedGlc();
  const { isModalOpen, onModalOpen, onModalClose } = useModalState();

  const { mutate: onArchiveGlc, isLoading } = useMutation(archiveGlc, {
    onSuccess: () => {
      setSelectedGlc(undefined);
      queryClient.invalidateQueries([QueryKeyEnum.GLC]);
      toast.dark(formatMessage({ id: AppMessages['glc.archive.success'] }));
      onModalClose();
    },
  });

  const onSubmit = () => {
    onArchiveGlc(selectedGlc.id);
  };

  return (
    <ArchiveGlc
      selectedGlc={selectedGlc}
      isModalOpen={isModalOpen}
      onModalClose={onModalClose}
      onModalOpen={onModalOpen}
      isLoading={isLoading}
      onSubmit={onSubmit}
    />
  );
};
